export const reviews = [
  {
    name: "Pinki Verma",
    content:
      "I have been staying in this hostel for a couple of months and my experience has been nothing but amazing. This hostel is equipped with all the required amenities such as single room double room AC RO water Wi-Fi housekeeping food facility. It's well maintained on a regular basis and the owner is very cooperative.",
  },
  {
    name: "Ambuja Kumari",
    content:
      "Newly constructed hostel on the for girls on main road at walking distance from MITS college and Gole ka Mandir Bus Stop. Owner is decent person. It has CCTV monitoring and ground floor is occupied by Bajaj Finance. We have several shops and restaurants within half Km radius. Several MITS students live here as of now. It has rooms available for student and working females.",
  },
  {
    name: "Abhi Singh",
    content:
      "This is a newly constructed hostel for girls. Owner is very cooperative. It’s at a prime location on main road with a walking distance from Gole ka Mandir Bus stop. It’s on 1st floor. Ground floor is occupied by Bajaj Finance. We have several shops in front and around for ease of shopping general items as well as food. It’s primarily occupied by student girls of MITS.",
  },
  {
    name: "Anuj Rampal",
    content:
      "My sister stayed here. Good facility like wifi , attached bathrooms , geysers, hot and cold drinking water supply, and the owner is supportive too.",
  },
  {
    name: "Shreya",
    content:
      "The rooms are really nice with attached washroom. Daily cleaning and great environment. All the necessary facilities are provided.",
  },
  {
    name: "Shruti Gupta",
    content:
      "It is nice hostel and affordable for Mits Clg students. The facilities are good",
  },
  {
    name: "Mehak Chaudhary",
    content:
      "Stayed here for a few months, amazing experience, clean, quite and secure place,, good location, close to railway station and hospital.",
  },
];

export const images = [
  "https://lh3.googleusercontent.com/p/AF1QipNJnL3jXkA3E28ocsarN4QKvCDgdMXjzPtN6D0p=s1360-w1360-h1020",
  "https://lh3.googleusercontent.com/p/AF1QipP3mVQjd4-xCvXq-s76ZmTUjFj8S4evNnuhs7B_=s1360-w1360-h1020",
  "https://lh3.googleusercontent.com/p/AF1QipM35nLl7TQJEUx0tovGTYBTNdeeZAgpAOwctqBs=s1360-w1360-h1020",
  "https://lh3.googleusercontent.com/p/AF1QipMjj4VFH7Clp3QBMKiyngVT3oKWn8m7XvxcuQkv=s1360-w1360-h1020",
  "https://lh3.googleusercontent.com/p/AF1QipPz_sj3HgnlMllHefVzCEI6K-yAGhRcUppFZBeR=s1360-w1360-h1020",
  "https://lh3.googleusercontent.com/p/AF1QipPdi-WwBF4KeK5ikyzi-4kSM3s8kDr7rKCiCSqZ=s1360-w1360-h1020",
  "https://lh3.googleusercontent.com/p/AF1QipM24UZOGObzsZu_IPdIMfnmF4cUOS1BwFDoRNU3=s1360-w1360-h1020",
  "https://lh3.googleusercontent.com/p/AF1QipPMklCGgt03E6MDqS3I1spu0MWb3TT5pgkw42nw=s1360-w1360-h1020",
  "https://lh3.googleusercontent.com/p/AF1QipPdGWHIBPGScmrTuyinhtfSBPmFzX0X_Y0Zc4B5=s1360-w1360-h1020",
  "https://lh3.googleusercontent.com/p/AF1QipOgD7dHXSbtM4zecX60Y2j2mf9fCLdRH9aC0hHO=s1360-w1360-h1020",
  "https://lh3.googleusercontent.com/p/AF1QipM_T_y75cPQUUcUAykdgWrapWOMdODTF4wBn2N2=s1360-w1360-h1020",
  "https://lh3.googleusercontent.com/p/AF1QipM_T_y75cPQUUcUAykdgWrapWOMdODTF4wBn2N2=s1360-w1360-h1020",
  "https://lh3.googleusercontent.com/p/AF1QipNlgYGML_mrBgnWmYH6nEfefP6AAxdvVyaBgDZh=s1360-w1360-h1020",
  "https://lh3.googleusercontent.com/p/AF1QipOvWUPN9-WckfhgIVoTFHWEQpWUo-cIKbjP7NVj=s1360-w1360-h1020",
];

export const amenities = [
  "Well Furnished Sharing/Private Rooms",
  "High Speed Wi-Fi",
  "Attached Washroom & Balcony",
  "CCTV & Security Guard",
  "24*7 RO Water",
  "24*7 Power Backup",
  "Hot Water Supply",
  "Daily Housekeeping",
  "Separate Cupboard",
  "Beds with Mattress & Pillow",
  "Terrace Garden",
  "Study Table & Chair",
];
